import React from 'react';
import DeviceScanCard from '../../../../components/DeviceScan/DeviceScanCard';
import useDeviceScanSession from '../../../../components/DeviceScan/useDeviceScanSession';

function DeviceScan(props) {
    const { transaction } = props;
    const { deviceScan, sdkMetadata } = useDeviceScanSession(
        transaction.company_key,
        transaction.source?.session_id
    );

    return (
        <DeviceScanCard
            deviceScan={deviceScan}
            channel={transaction.source?.channel}
            sdkMetadata={sdkMetadata}
        />
    );
}

export default DeviceScan;
